import { render, staticRenderFns } from "./Twosteps.vue?vue&type=template&id=5d2d87a6"
import script from "./Twosteps.vue?vue&type=script&lang=js"
export * from "./Twosteps.vue?vue&type=script&lang=js"
import style0 from "./Twosteps.vue?vue&type=style&index=0&id=5d2d87a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports